import { Modal } from "antd";
import { useCallback } from "react";

type ConfirmAddAllOptions = {
  title: string;
  content?: React.ReactNode;
  onOk: () => Promise<void> | void;
};

export function useConfirmAddAll() {
  const confirmAddAll = useCallback(
    ({ title, content, onOk }: ConfirmAddAllOptions) => {
      Modal.confirm({
        title: title,
        content,
        okText: "Добавить вce",
        cancelText: "Отмена",
        okButtonProps: {
          style: {
            background: "#FAAD14",
            borderColor: "#FAAD14",
            color: "#ffffff",
          },
        },
        onOk,
      });
    },
    []
  );

  return confirmAddAll;
}
